import React from 'react';
import GameModeMenu from '../components/GameModeMenu';
import BiggestRatingChanges from '../components/BiggestRatingChanges';

export default function Insights() {
    const tabContentFn = (gameMode, rankingType) => {
        return <BiggestRatingChanges gameMode={gameMode.key}></BiggestRatingChanges>;
    }
    return (
        <div className='flex'>
            <GameModeMenu tabContentFn={tabContentFn}></GameModeMenu>
        </div>
    );
};